exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "item {\n    display: block;\n    border-bottom: 1px solid #ddd;\n}\n\nitem:last-child {\n    border-bottom: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/items/ListForDate.component.css
// module id = ../../../../../src/app/items/ListForDate.component.css
// module chunks = main